import { CommentButton } from './CommentButton';
import { CommentsToggle } from './CommentsToggle';

type Props = {
  commentCount: number;
  isExpanded: boolean;
  onToggle: () => void;
  onComment: () => void;
};

export const PostFooter = ({
  commentCount,
  isExpanded,
  onToggle,
  onComment,
}: Props) => (
  <div className="flex flex-row items-center justify-between">
    <CommentsToggle
      count={commentCount}
      singular="comment"
      plural="comments"
      isExpanded={isExpanded}
      onToggle={onToggle}
    />
    <CommentButton label="Comment" onClick={onComment} />
  </div>
);
